<template>
  <a-form
    id="my_form_styl"
    :label-col="{
      span: 12,
    }"
    :wrapper-col="{
      span: 12,
    }"
    :form="form"
  >
    <div
      style="text-align: center; font-weight: 700"
      v-show="document.invoiceAutoNumber"
    >
      {{ document.invoiceAutoNumber }} | {{ document.invoiceTitle }}
    </div>
    <a-form-item
      :label="$t('File name')"
      style="margin-top: 10px; border-top: 1px solid #d3d3d3"
    >
      <a-tooltip>
        <template slot="title">
          <span>{{ document.NAME }}</span>
        </template>
        <span>{{ document.NAME }}</span>
      </a-tooltip>
    </a-form-item>

    <a-form-item :label="$t('Status')">
      <a-tag style="font-weight: bold" :color="statusTag.color">{{
        $t(document.status)
      }}</a-tag>
    </a-form-item>

    <a-form-item :label="$t('Main Company')">{{
      getCompany(document.my_company) 
    }}</a-form-item>

    <a-form-item :label="$t('Contractor')">{{
      getCompany(document.kontragent)
    }}</a-form-item>

    <a-form-item :label="$t('Bank account')">{{
      document.bankAccount
    }}</a-form-item>
    <a-form-item :label="$t('Invoice number')">{{
      document.num_doc
    }}</a-form-item>
    <a-form-item :label="$t('Type')">{{ invoiceTypeSelect[document.invoiceType] }}</a-form-item>
    <a-form-item v-if="document.invoiceCorrection" :label="$t('Correction')">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div>{{ document.invoiceCorrection }}</div>
        <a-button @click="showPreview" type="primary" icon="eye" />
      </div>
    </a-form-item>

    <a-form-item v-if="document.correctionBack" :label="$t('Correction')">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div>{{ document.correctionBack }}</div>
        <a-button @click="showPreview" type="primary" icon="eye" />
      </div>
    </a-form-item>

    <a-form-item :label="$t('Payment')">
      <a-col :span="12">{{ document.payment.type }}</a-col>
    </a-form-item>

    <a-form-item :label="$t('Currency')">
      <a-col :span="12">{{ document.currency.code }}</a-col>
      <a-col :span="12">{{ document.currency.val }}</a-col>
    </a-form-item>

    <a-form-item :label="$t('Keywords')">
      <span style="white-space: normal">
        <a-tag v-for="(item, index) in document.key_words" :key="index">{{
          item
        }}</a-tag>
      </span>
    </a-form-item>

    <a-form-item :label="$t('Tag')">
      <a-tag v-for="(item, index) in document.Teczka" :key="index">{{
        item
      }}</a-tag>
    </a-form-item>

    <a-form-item :label="$t('Owner')">
      <span>{{
        getCompanyAssign(document.my_company)
      }}</span>
    </a-form-item>

    <a-form-item
      :label="$t('Date of receiving')"
      style="margin-top: 50px; border-top: 1px solid #d3d3d3"
      >{{ document.date_send }}</a-form-item
    >

    <a-form-item :label="$t('Date of issue')">{{
      document.date_recept
    }}</a-form-item>

    <a-form-item :label="$t('Sale date')">{{ document.saleDate }}</a-form-item>

    <a-form-item :label="$t('Date of payment')">{{
      document.paymentDate
    }}</a-form-item>

    <a-form-item :label="$t('Planned date')">{{
      document.plannedDate
    }}</a-form-item>
    <a-form-item :label="$t('Reminder')">{{
      document.reminderDate
    }}</a-form-item>

    <a-divider style="margin-top: 50px; margin-bottom: 0px">{{ $t('Zapłata') }} </a-divider>
    <a-timeline style="padding: 15px 0 0 25px">
      <a-timeline-item v-for="(item, index) in kwotaVals.history" :key="index">
        <a-row type="flex" justify="space-around" align="middle">
          <a-col :span="4">
            {{ item.date }}
          </a-col>
          <a-col :span="4">
            {{ item.payment }}
          </a-col>
          <a-col :span="4">
            {{
              getUser(item.user)
            }}
          </a-col>
        </a-row>
      </a-timeline-item>
    </a-timeline>

    <span style="background-color: #e6f7ff">
      <a-form-item
        :label="$t('Kwota Netto')"
        style="
          margin-top: 50px;
          border-top: 1px solid #d3d3d3;
          background-color: #e6f7ff;
        "
      >
        <a-statistic :precision = 2 :value="document.Quota.Netto" />
      </a-form-item>
      <a-form-item :label="$t('Kwota Vat')" style="background-color: #e6f7ff">
        <a-statistic :precision = 2 :value="document.Quota.Vat" />
      </a-form-item>
      <a-form-item
        :label="$t('Kwota Brutto')"
        style="background-color: #e6f7ff"
      >
        <a-statistic :precision = 2 :value="document.Quota.Bruto" />
      </a-form-item>
    </span>
  </a-form>
</template>
<script>
import moment from "moment";
import { requestStep } from "@/requestFunc";

export default {
  props: [
    "document",
    "statusTag",
    "MY_COMPANY_LIST",
    "COMPANY_LIST",
    "USER_LIST",
    "info",
    "key_words",
    "responsible",
    "profile",
    "currentSix",
  ],
  data() {
    return {
      kwotaVals: {},
      invoiceTypeSelect: {
        "Faktura Kosztowa": this.$t("Faktura Kosztowa"),
        "Proforma": this.$t("Proforma"),
        "VAT Marza": this.$t("Faktura do Proformy"),
        "Korygujaca": this.$t("Korygująca"),
        "Faktura zaliczkowa": this.$t("Faktura zaliczkowa"),
        "Faktura koncowa": this.$t("Faktura końcowa"),
      }
    };
  },
  methods: {
    moment,
    getUser(id) {
      let user = this.document.userList.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : "";
    },
    getCompanyAssign(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.ASSIGNED_BY_NAME : "";
    },
    getCompany(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.TITLE : "";
    },
    submit() {
      this.form.validateFields(() => {
        this.changeSpinning();
        for (let item of this.document.invoiceTable) {
          if (
            item.sum_distribution.findIndex((x) => x.accept.status == false) !=
            -1
          ) {
            break;
          }
        }
        requestStep({
          run: "acceptationBiuro",
          mainid: this.document.mainid,
        })
          .done((data) => {
            var res = JSON.parse(data);
            this.document.status = res.status;
            this.$message.success(this.$t("Invoice confirmation success"));
          })
          .fail((e) => {
            console.err(e);
            this.$message.error(this.$t("Error confirmation invoice"));
          })
          .always(() => {
            this.onback(this.document.ID, true);
            this.changeSpinning();
          });
      });
    },
    onback(idFile, unshift) {
      this.$emit("onback", {
        visible_doc: true,
        unshift_elem: this.currentSix == 5 ? false : unshift,
        remove_elem: idFile,
      });
    },
    showPreview() {
      this.$emit("showPreview", false);
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
  },
  mounted() {
    this.form = this.$form.createForm(this, { name: "form_5" });
    this.kwotaVals = Object.assign({}, this.kwotaVals, this.document.kwota);

    BX24.fitWindow();
  },
};
</script>

<style scoped>
</style>
